import { axiosInstanceTasks } from "../axios";
import { AppConfiguration, RequestResponse } from "../types";

export const getInheritedConfig = async (
  taskId: string | null
): Promise<RequestResponse<{ records: AppConfiguration[]; total: number }>> => {
  try {
    const response = await axiosInstanceTasks.get(
      `/app-configs/inherited/${taskId || ""}`
    );

    const records = response.data.data;
    const total = records.length;

    return {
      error: false,
      data: {
        records,
        total,
      },
    };
  } catch (err) {
    console.error("Unable to fetch app configs: ", { err });
    return {
      error: true,
      message: err.response?.data?.error_description?.includes(
        "Access is denied"
      )
        ? "Access denied: You do not have permission to perform this activity."
        : err.response?.data?.error_description ||
          err.response?.data?.message ||
          err.message ||
          err,
      data: null,
    };
  }
};
